const lightPalette = {
  text: {
    primary: '#121312',
    secondary: '#A1A3A7',
    disabled: '#DDDEE0',
  },
  primary: {
    dark: '#00f2fe',
    main: '#4facfe',
    light: '#636669',
  },
  secondary: {
    dark: '#0FDA6D',
    main: '#4facfe',
    light: '#B0FFC9',
    background: '#EFFFF4',
  },
  border: {
    main: '#A1A3A7',
    light: '#DCDEE0',
    background: '#F4F4F4',
  },
  error: {
    dark: '#AC2C3B',
    main: '#FF5F72',
    light: '#FFB4BD',
    background: '#FFE6EA',
  },
  success: {
    dark: '#028D4C',
    main: '#00B460',
    light: '#72F5B8',
    background: '#EFFAF1',
  },
  info: {
    dark: '#52BFDC',
    main: '#5FDDFF',
    light: '#B7F0FF',
    background: '#EFFCFF',
  },
  warning: {
    dark: '#C04C32',
    main: '#FF8061',
    light: '#FFBC9F',
    background: '#FFF1E0',
  },
  background: {
    default: '#F4F4F4',
    main: '#F4F4F4',
    paper: '#FFFFFF',
    light: '#EFFFF4',
  },
  backdrop: {
    main: '#636669',
  },
  logo: {
    main: '#121312',
    background: '#EEEFF0',
  },
  static: {
    main: '#121312',
  },
}

export default lightPalette
